import T from "../theme";
import { TIMELINE } from "../data";
import Reveal from "../components/Reveal";
import { Section, SectionLabel } from "../components/Section";

export default function TimelineSection() {
  return (
    <Section id="timeline" style={{ background: T.bg0 }}>
      <div className="section-pad" style={{ maxWidth: 900, margin: "0 auto" }}>
        <Reveal><SectionLabel text="Timeline" /></Reveal>
        <Reveal delay={0.05}>
          <h2 style={{ color: T.white, fontSize: "clamp(28px,4vw,52px)", fontWeight: 900, margin: "0 0 48px", letterSpacing: -1 }}>
            Event Schedule
          </h2>
        </Reveal>

        <div style={{ position: "relative" }}>
          <div className="timeline-line" style={{
            background: `linear-gradient(to bottom, transparent, ${T.blue} 15%, ${T.blue} 85%, transparent)`,
          }} />

          {TIMELINE.map((ev, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <div className="timeline-row">
                <div className="timeline-date">
                  <span style={{ fontFamily: T.mono, fontSize: 11, color: ev.done ? T.blue : T.gray3, fontWeight: 600 }}>
                    {ev.date}
                  </span>
                </div>
                <div style={{
                  width: 13, height: 13, borderRadius: "50%", flexShrink: 0, marginTop: 2,
                  background: ev.done ? T.blue : T.bg3,
                  border: `2px solid ${ev.done ? T.blue : T.gray3}`,
                  boxShadow: ev.done ? "0 0 12px rgba(59,130,246,0.6)" : "none",
                  zIndex: 1, position: "relative",
                }} />
                <div style={{
                  flex: 1, background: T.bgCard,
                  border: `1px solid ${ev.done ? T.border : T.borderDim}`,
                  borderRadius: 6, padding: "16px 20px",
                  borderLeft: ev.done ? `3px solid ${T.blue}` : `3px solid ${T.gray3}`,
                }}>
                  <div style={{ color: ev.done ? T.white : T.gray2, fontWeight: 700, fontSize: "clamp(13px,1.5vw,15px)", marginBottom: 6 }}>{ev.label}</div>
                  <div style={{ color: T.gray2, fontSize: 13, lineHeight: 1.5 }}>{ev.desc}</div>
                  {ev.done && (
                    <div style={{
                      marginTop: 8, display: "inline-block",
                      background: "rgba(59,130,246,0.12)", border: "1px solid rgba(59,130,246,0.25)",
                      borderRadius: 3, padding: "2px 8px",
                      fontFamily: T.mono, fontSize: 9, color: T.blue, letterSpacing: 1,
                    }}>COMPLETED</div>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
